<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:loading="isDeleteLoading"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('name') }} : {{ item.nome }} - {{ $t('email') }} : {{ item.email }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<div class="container__crudactions__cruddownload__download">
					<!-- <DownloadButton /> -->
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 0.5rem">
					<InputText
						v-model="model.nome"
						:label="$t('name')"
					/>
					<InputText
						v-model="model.email"
						:label="$t('email')"
					/>
					<InputText
						v-model="model.cargo"
						:label="$t('jobRole')"
					/>
					<!-- <Dropdown
            :label="$t('schooling')"
            :options="[]"
            v-model="model.escolaridade"
          /> -->
					<DatePicker
						v-model="model.nascimento"
						:label="$t('birthDate')"
						:max-date="minDate.toISOString()"
					/>

					<RadioButtons
						v-model="model.genero"
						:label="$t('genre')"
						group-name="genero"
						:options="[
							{ label: $t('female'), value: 'F' },
							{ label: $t('male'), value: 'M' },
							{ label: $t('other'), value: 'O' },
						]"
					/>

					<DropdownFk
						v-model="model.perfisAcesso"
						:label="$t('accessProfile')"
						:hidden-properties="[
							'roles',
							'descricaoPerfilDeAcesso',
							'perfilDeAcessoId',
							'nomePerfilDeAcesso',
						]"
						:dropdown-options="acessos"
					/>

					<label
						for=""
						class="text-xl font-bold"
						>{{ $t('foto') }}</label
					>
					<div class="flex justify-center">
						<img
							:src="imagemUsuario"
							alt=""
							class="h-20 w-20 rounded-full"
						/>
					</div>
					<NewFileUpload
						:files="model.foto"
						@onInput="handleFileInput"
					/>

					<div
						style="
							display: flex;
							gap: 0.5rem;
							justify-content: space-between;
							align-items: baseline;
							background: var(--color-background);
							padding: 1rem 0.5rem;
							border-radius: 5px;
							cursor: pointer;
							margin-top: 1rem;
						"
						@click="customPassword = !customPassword"
					>
						<div style="display: flex; gap: 0.5rem">
							<p style="margin: 0; font-size: 0.9rem; font-weight: bold">
								{{
									!isEdit
										? `${$t('set')}
                                                  ${$t('customPassword')}`
										: `${$t('changePassword')}`
								}}
							</p>
							<Tooltip
								v-show="!isEdit"
								:titulo="`${$t('customPassword')}`"
								:subtitulo="`${$t('set')} ${$t('customPassword')}`"
								:conteudo="$t('helpCustomPassword')"
							/>
						</div>
						<i
							style="font-size: 1rem"
							:class="`fas fa-angle-${customPassword ? 'up' : 'down'}`"
						/>
					</div>
					<div
						v-if="customPassword"
						style="display: flex; flex-direction: column; gap: 1rem"
					>
						<InputPassword
							v-show="isEdit"
							v-model="model.oldPassword"
							label="Senha atual"
						/>
						<InputPassword
							v-model="model.password"
							:label="!isEdit ? $t('password') : 'Senha nova'"
						/>
						<InputPassword
							v-show="isPasswordValid"
							v-model="model.confirmaPassword"
							:label="`${$t('confirm')} ${$t('password')}`"
						/>
						<div style="padding: 0.5rem; background: var(--color-background); border-radius: 5px">
							<p
								style="margin-bottom: 5px"
								:class="{ 'correct-requirement': passwordHasLower }"
							>
								<i
									v-show="passwordHasLower"
									class="fas fa-check correct-requirement"
								/>
								{{ $t('passwordHasToHaveLowerLetter') }}
							</p>
							<p
								style="margin-bottom: 5px"
								:class="{ 'correct-requirement': passwordHasUpper }"
							>
								<i
									v-show="passwordHasUpper"
									class="fas fa-check correct-requirement"
								/>
								{{ $t('passwordHasToHaveUpperLetter') }}
							</p>
							<p
								style="margin-bottom: 5px"
								:class="{ 'correct-requirement': passwordHasDigit }"
							>
								<i
									v-show="passwordHasDigit"
									class="fas fa-check correct-requirement"
								/>
								{{ $t('passwordHasToHaveDigit') }}
							</p>
							<p
								style="margin-bottom: 5px"
								:class="{ 'correct-requirement': passwordHasSpecials }"
							>
								<i
									v-show="passwordHasSpecials"
									class="fas fa-check correct-requirement"
								/>
								{{ $t('passwordHasToHaveSpecials') + ' ' + specials.split('').join(' ') + '' }}
							</p>
							<p
								style="margin-bottom: 5px"
								:class="{ 'correct-requirement': passwordHasLength }"
							>
								<i
									v-show="passwordHasLength"
									class="fas fa-check correct-requirement"
								/>
								{{ $t('passwordHasToHaveAtLeastLength', { x: length }) }}
							</p>
							<p
								style="margin-bottom: 5px"
								:class="{ 'correct-requirement': model.password && !passwordHasNotWhitespaces }"
							>
								<i
									v-show="model.password && !passwordHasNotWhitespaces"
									class="fas fa-check correct-requirement"
								/>
								{{ $t('passwordHasToHaveNoWhitespaces') }}
							</p>
							<p
								v-show="isPasswordValid"
								style="margin-bottom: 5px"
								:class="{ 'correct-requirement': model.password === model.confirmaPassword }"
							>
								<i
									v-show="model.password === model.confirmaPassword"
									class="fas fa-check correct-requirement"
								/>
								{{ $t('passwordsMustMatch') }}
							</p>
						</div>
					</div>

					<div class="container__crud__crudform__buttons">
						<Button
							:label="$t('cancel')"
							color="trv-secondary"
							semantic-class="mini"
							outlined
							@click="changeFormAndCloseAllActions"
						/>
						<Button
							:label="$t('save')"
							color="trv-default"
							semantic-class="mini"
							:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
							@click="saveClick()"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DatePicker from '../../../components/DatePicker/DatePicker'
// import DownloadButton from "../../../components/DownloadButton/DownloadButton";
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
// import Dropdown from "../../../components/Dropdown/Dropdown";
import InputPassword from '../../../components/InputPassword/InputPassword'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../components/Pagination/Pagination'
import RadioButtons from '../../../components/RadioButtons/RadioButtons'
import Tooltip from '../../../components/Tooltip/Tooltip'
import NewFileUpload from '../../../components/NewFileUpload/NewFileUpload'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'
import useMagicRegExp from '../../../mixins/useMagicRegExp'

import {
	updateUsuarioComFoto,
	createUsuarioComFoto,
	deleteUsuariosByIdList,
	getUsuarios,
} from '../../../services/requests/UsuarioRequests.js'

import { getPerfisDeAcesso } from '../../../services/requests/PerfilDeAcessoRequests.js'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Button,
		CrudForm,
		CrudTable,
		DatePicker,
		KebabMenu,
		RadioButtons,
		NewFileUpload,
		Tooltip,
		ExclusionAlert,
		// DownloadButton,
		DropdownCheckbox,
		DropdownFk,
		// Dropdown,
		InputSearch,
		InputText,
		Pagination,
		InputPassword,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins, useMagicRegExp],
	data() {
		return {
			isDeleteLoading: false,
			customPassword: false,
			perfisDeAcesso: [],
			intention: {},
			showExclusionAlert: false,
			headersSelecionados: ['nome', 'email'],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				fotoUrl: '',
				id: '',
				nome: '',
				email: '',
				cargo: '',
				genero: '',
				escolaridade: '',
				nascimento: '',
				perfisAcesso: '',
				oldPassword: undefined,
				password: undefined,
				confirmaPassword: undefined,
				foto: [],
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'codigo',
				titleCardPropertie: 'codigo',
			},

			tableHeaders: [
				{ key: 'nome', value: this.$t('name'), isActive: true },
				{ key: 'email', value: this.$t('email'), isActive: true },
				{
					key: 'cargo',
					value: this.$t('jobRole'),
					isActive: false,
				},
				{
					key: 'nascimentoFormatado',
					value: this.$t('birthDate'),
					isActive: false,
				},
				{
					key: 'genero',
					value: this.$t('genre'),
					isActive: false,
				},
				{
					key: 'perfil',
					value: this.$t('accessProfile'),
					isActive: false,
				},
				{
					key: 'usuarioBloqueado',
					value: this.$t('blocked'),
					isActive: false,
				},
			],
			/**
			 * talhoes que serão dispostas no dropdown para atrelar ao plantio
			 */
			talhoes: [],

			/**
			 * estratos florestal que serão dispostos no dropdown para atrelar ao plantio
			 */
			estratoFlorestais: [],
		}
	},
	computed: {
		minDate() {
			return new Date(new Date().getTime() - 568036800000)
		},
		imagemUsuario() {
			return (
				this.model.fotoUrl ||
				`https://ui-avatars.com/api/?name=${this.model.nome || 'Novo Usuario'}`
			)
		},
		novoCodigo() {
			return (
				this.modelList.map((user) => Number(user.codigo)).sort((a, b) => (a < b ? 1 : -1))[0] + 1
			)
		},

		acessos() {
			return this.perfisDeAcesso?.map((perfil) => {
				return Object.assign(perfil, {
					[this.$t('name')]: perfil.nomePerfilDeAcesso,
					[this.$t('description')]: perfil.descricaoPerfilDeAcesso,
					id: perfil.perfilDeAcessoId,
				})
			})
		},
		passwordHasUpper() {
			return this.model.password ? this.checkForUppercase(this.model.password) : null
		},
		passwordHasLower() {
			return this.model.password ? this.checkForLowercase(this.model.password) : null
		},
		passwordHasDigit() {
			return this.model.password ? this.checkForDigit(this.model.password) : null
		},
		passwordHasSpecials() {
			return this.model.password ? this.checkForSpecial(this.model.password) : null
		},
		passwordHasLength() {
			return this.model.password ? this.checkForLength(this.model.password) : null
		},
		passwordHasNotWhitespaces() {
			return this.model.password ? this.checkForWhitespaces(this.model.password) : null
		},
		isPasswordValid() {
			return this.model.password ? this.passwordIsValid(this.model.password) : null
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			let obrigatorios =
				this.model.nome &&
				this.model.cargo &&
				this.model.perfisAcesso &&
				this.model.email &&
				this.model.nascimento &&
				this.model.genero

			if (this.model.password) {
				obrigatorios =
					obrigatorios &&
					this.isPasswordValid &&
					this.model.confirmaPassword === this.model.password
			}

			return obrigatorios
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		console.log(this.$route.query)
		this.quantityPerPage = 10
		this.orderTable = ['codigo']

		getUsuarios().then((response) => {
			const { result: usuarios } = response.data
			usuarios.forEach((usuario) => {
				this.formataUsuarioParaTabela(usuario)
			})
			this.modelList = usuarios

			if (this.$route.query.email) {
				this.model = this.modelList.find((f) => f.email === this.$route.query.email)
				this.showEditModelForm(this.model)
			}
		})

		getPerfisDeAcesso().then((response) => {
			this.perfisDeAcesso = response.data.result
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		usuarioFormatado() {
			const id = uuidv4()

			const formData = new FormData()
			formData.append('codigo', this.novoCodigo.toString())
			formData.append('id', id)
			formData.append('Nome', this.model.nome)
			formData.append('DataDeNascimento', this.model.nascimento)
			formData.append('Cargo', this.model.cargo)
			formData.append('Genero', this.model.genero)
			formData.append('Escolaridade', this.model.escolaridade)
			formData.append('PerfilDeAcessoId', this.model.perfisAcesso)
			formData.append('Email', this.model.email)
			formData.append('Senha', this.model.password)
			formData.append('ConfirmarSenha', this.model.confirmaPassword)

			if (this.model.foto.length) {
				console.log('🚀 ~ file: Usuarios.vue:211 ~ this.model.foto.length:', this.model.foto.length)
				formData.append('Foto', this.model.foto[0], 'imagem' + id)
			}

			return formData
		},
		usuarioFormatadoUpdate() {
			const formData = new FormData()

			const usuario = this.model

			formData.append('codigo', usuario.codigo)
			formData.append('id', usuario.id)
			formData.append('Nome', usuario.nome)
			formData.append('DataDeNascimento', usuario.nascimento)
			formData.append('Cargo', usuario.cargo)
			formData.append('Genero', usuario.genero)
			formData.append('Escolaridade', usuario.escolaridade)
			formData.append('PerfilDeAcessoId', usuario.perfisAcesso)
			formData.append('Email', usuario.email)
			formData.append('SenhaAntiga', usuario.oldPassword)
			formData.append('SenhaNova', usuario.password ?? '')

			if (usuario.foto.length) {
				formData.append('Foto', usuario.foto[0], 'imagem' + usuario.id)
			}

			return formData
		},
		handleFileInput(files) {
			this.model.foto = [...files]

			const reader = new FileReader()

			reader.onload = (event) => {
				this.model.fotoUrl = event.target.result
			}

			reader.readAsDataURL(this.model.foto[0])
		},
		formataUsuarioParaTabela(usuario) {
			usuario.nascimentoFormatado = usuario.dataDeNascimento
				? new Date(usuario.dataDeNascimento).toLocaleDateString(navigator.language, {
						month: 'short',
						day: 'numeric',
						year: 'numeric',
					})
				: this.$t('notInformed')
			usuario.perfil = usuario.perfilDeAcesso.descricao
			usuario.perfisAcesso = usuario.perfilDeAcesso.id
			usuario.isCheckedToDelete = false
		},
		/**
		 * Cria novo Usuário no banco de dados
		 */
		create() {
			const usuarioFormData = this.usuarioFormatado()
			// Extrai o ID que foi gerado no usuarioFormatado
			const idGerado = usuarioFormData.get('id')

			createUsuarioComFoto(usuarioFormData)
				.then((response) => {
					const { result: message, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						// Clona o model antes de limpar
						const novoUsuario = JSON.parse(JSON.stringify(this.model))

						// Atribui o ID gerado ao novo usuário
						novoUsuario.id = idGerado
						novoUsuario.codigo = this.novoCodigo
						novoUsuario.DataDeNascimento = novoUsuario.nascimento
						novoUsuario.dataDeNascimento = novoUsuario.nascimento
						novoUsuario.perfilDeAcesso = this.perfisDeAcesso.find(
							(ap) => ap.perfilDeAcessoId === novoUsuario.perfisAcesso,
						)

						// Formata o usuário para exibição na tabela
						this.formataUsuarioParaTabela(novoUsuario)

						// Adiciona à lista ANTES de limpar o model
						this.modelList.unshift(novoUsuario)

						// Agora limpa o formulário
						this.cleanModel()
						this.customPassword = false

						this.showForm = false

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageText: message,
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					}
				})
				.catch((err) => {
					const erros = err.response.data
					var mensagem = ''

					if (erros.includes('DuplicateUserName')) mensagem = this.$t('duplicatedusername')
					else if (erros.includes('EmailFormatoInvalido'))
						mensagem = this.$t('emailFormatoInvalido')
					else mensagem = this.$t('unknownusererror')

					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: mensagem,
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})

					this.disableSaveButton = false
				})
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataPlantioParaTabela(plantio) {
			plantio.isCheckedToDelete = false
			plantio.ptio_nr_area_efetiva = plantio.ptio_nr_area_efetiva?.toFixed(2)

			plantio.dataDoPlantioParaTabela = plantio.ptio_dt_plantio
				? new Date(plantio.ptio_dt_plantio).toLocaleDateString()
				: ''

			plantio.dataDaColheitaParaTabela = plantio.ptio_dt_colheita
				? new Date(plantio.ptio_dt_colheita).toLocaleDateString()
				: ''
		},

		/**
		 * Atualiza fazenda no banco de dados
		 */
		update() {
			updateUsuarioComFoto(this.usuarioFormatadoUpdate())
				.then((response) => {
					const { isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						const indexUsuario = this.modelList.map((m) => m.id).indexOf(this.model.id)
						this.$set(this.modelList, indexUsuario, JSON.parse(JSON.stringify(this.model)))

						this.cleanModel()
						this.customPassword = false
						this.showForm = false

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
				.catch((err) => {
					const erros = err.response.data
					var mensagem = ''

					if (erros.includes('DuplicateUserName')) mensagem = this.$t('duplicatedusername')
					else if (erros.includes('EmailFormatoInvalido'))
						mensagem = this.$t('emailFormatoInvalido')
					else mensagem = this.$t('unknownusererror')

					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: mensagem,
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})

					this.disableSaveButton = false
				})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const confirmResult = confirm(this.$t('confirmaExclusao'))
				if (confirmResult) {
					this.isDeleteLoading = true
					deleteUsuariosByIdList(this.modelsIdWithCheckedToDelete).then(() => {
						this.modelsIdWithCheckedToDelete.forEach((f) => {
							const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
							this.modelList.splice(indexToRemove, 1)
						})

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
						this.showExclusionAlert = false

						this.isDeleteLoading = false
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			this.model.foto = []
			this.model.nascimento = this.model.dataDeNascimento
			this.titleForm = `${this.$t('edit')} ${this.$t('user')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('user')}`
			// data padrão há 18 anos atrás
			this.model.nascimento = this.minDate.toISOString()
			this.model.foto = []
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm

			// Limpa o formulário ao fechar
			if (!this.showForm) {
				this.cleanModel()
				this.customPassword = false
			}
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
<style scoped>
.correct-requirement {
	color: var(--color-success-background);
	font-weight: bold;
}
</style>
